var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickbooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#2CA01C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26087 24C6.26087 29.1466 10.5183 33.2852 15.8127 33.2852H17.1773V29.8364H15.8127C12.4832 29.8364 9.8087 27.2365 9.8087 24C9.8087 20.7634 12.4832 18.1636 15.8127 18.1636H19.0876V36.2034C19.0876 38.1135 20.6705 39.6522 22.6355 39.6522V14.7148H15.8127C10.5183 14.7148 6.26087 18.8534 6.26087 24ZM32.1873 14.7148H30.8227V18.1636H32.1873C35.5168 18.1636 38.1913 20.7634 38.1913 24C38.1913 27.2365 35.5168 29.8364 32.1873 29.8364H28.9124V11.7966C28.9124 9.88651 27.3295 8.34782 25.3646 8.34782V33.2852H32.1873C37.4817 33.2852 41.7391 29.1466 41.7391 24C41.7391 18.8534 37.4817 14.7148 32.1873 14.7148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbooks);
export default __webpack_public_path__ + "static/media/Quickbooks.e81733ef.svg";
export { ForwardRef as ReactComponent };